export default {
  name: 'marking--orderStatus',
};